module.exports = __webpack_public_path__ + "img/xiaofeng-img4.95308382.png";